export const getAgentTypeOptionsUrl = () => 'business/agent_action_types';
